<template>
  <v-app>
    <!-- ----------------------------------------------------------------------------------
    # Haupt-Content zentriert
    ----------------------------------------------------------------------------------- -->
    <v-main>
      <v-container class="main-container">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import axios from "axios";

export default {
  name: "App",
  components: { },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.loadUser();
  },
  methods: {
    async loadUser() {
      try {
        const response = await axios.get("/user");
        const $user = response.data;
        this.$store.dispatch("user", $user);
        this.$i18n.locale = $user?.localize || "en";
      } catch (error) {
        console.error(error);
      }
    },
    logout() {
      localStorage.removeItem("token");
      this.$store.dispatch("user", null);
      this.$router.push("/login");
    },
  },
};
</script>

<!--<style scoped>-->
<style>
  /* Hauptcontainer zentriert und kompakt */
  .main-container {
    max-width: 100% auto;
    margin: 5px auto;
    padding: 5px;
  }

  /* Feine, elegante Schrift global */
  body, input, textarea, select, button {
    font-family: "Fira Sans", Verdana, Geneva, Tahoma, sans-serif;
    font-weight: 400;
    font-size: 0.78rem; /* kleiner und filigran */
  }

  /* Buttons filigran, wie "Anmelden" */
  .v-btn {
    font-size: 0.78rem;
    font-weight: 500;
    padding: 6px 12px;
    text-transform: none;
    border-radius: 6px;
  }

  /* Formulare und Inputs feiner */
  .v-input input,
  .v-input textarea {
    font-size: 0.78rem;
  }

  .v-label {
    font-size: 0.78rem;
  }

  .footer-text {
    font-size: 0.75rem; /* kleiner als Standard */
    font-weight: 300; /* optional filigran */
  }

  .nav-link {
    text-decoration: none;
    color: #333;
    font-family: "Aptos", "Roboto", sans-serif;
    font-weight: 300;
    font-size: 0.82rem;
  }

  .compact-item {
    min-height: 22px !important; /* statt 48px */
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  /* Buttons filigran */
  .btn-login {
    font-size: 0.78rem;
    font-weight: 500;
    padding: 0.3rem 0.6rem;
    border-radius: 5px;
    text-transform: none;
  }

  /* Sprachwahl Chips */
  .selectLanguage .v-chip {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    font-size: 0.75rem;
    height: 20px;
    margin-top: auto;
  }

  .selectLanguage_v-list-item {
    margin-top: -15px; /* steuert den Zeilenabstand der Auswahlliste in einer Select- oder Comobox */
    margin-bottom: -15px; /* steuert den Zeilenabstand der Auswahlliste in einer Select- oder Comobox */
  }
</style>
